"use client"

import React, { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import { getUserLocation } from "../../utils/location"
import { Capitalize, trimUnderScore, isValid } from "../../common/util"
import IsolatedStatusModal from "../../components/StatusModal"
import routes from "../../routes/URL";

import {
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Button,
  IconButton,
  Input,
  Grid,
  Box,
  Container,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import Toast from "../../components/Toast"

const FileUploadWithPreview = ({ label, id, name, accept, onChange, value ,onModified}) => {
  const [file, setFile] = React.useState(value)
  const [previewUrl, setPreviewUrl] = React.useState(typeof value === "string" ? value : null)

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    if (selectedFile) {
      setFile(selectedFile)
      const fileUrl = URL.createObjectURL(selectedFile)
      setPreviewUrl(fileUrl)

      if (onChange) onChange(selectedFile)
      if (onModified) onModified(name) // Call onModified with the field name
    }
  }


  const handleUploadClick = () => {
    document.getElementById(id).click()
  }

  return (
    <Box>
      <input type="file" id={id} name={name} style={{ display: "none" }} accept={accept} onChange={handleFileChange} />

      <Box
        sx={{
          border: "2px dashed #ccc",
          padding: "20px",
          textAlign: "center",
          cursor: "pointer",
          marginTop: "10px",
          borderRadius: "8px",
          backgroundColor: "rgba(0, 0, 0, 0.02)",
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "#FFC857",
            backgroundColor: "rgba(255, 200, 87, 0.05)",
          },
        }}
        onClick={handleUploadClick}
      >
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item>
            <Box sx={{ fontSize: "30px", color: "#FFC857" }}>
              <i className="fa fa-upload"></i>
            </Box>
          </Grid>
          <Grid item>
            <Typography variant="subtitle1">{label}</Typography>
          </Grid>
        </Grid>
      </Box>

      {(previewUrl || (typeof file === "string" && file)) && (
        <Box mt={2} textAlign="center">
          <img
            src={previewUrl || file}
            alt="Document Preview"
            style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "4px" }}
          />
        </Box>
      )}
    </Box>
  )
}

class ListHotelScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      outlet: "Restaurant",
      outletCategories: [],
      user_id: "",
      hotel_name: "",
      outlet_category: "",
      owner_name: "",
      email: "",
      website: "",
      adhar_number: "",
      fssai_number: "",
      shop_act_number: "",
      document_type: "",
      gst_number: "",
      bank_name: "",
      bank_branch_name: "",
      bank_account_number: "",
      ifsc_code: "",
      currency: "",
      lat: "",
      lng: "",
      adhar_file: "",
      gst_file: "",
      fssai_file: "",
      shop_act_file: "",
      pan_file: "",
      document_file: "",
      qr_image: "",
      hotel_photo: "",
      qr_code: null,
      hotel_phone: "",
      previewFile: null,
      address: null,
      apartment: null,
      city: null,
      state: null,
      country: null,
      pin_code: null,
      mounted: false,
      cancelled_cheque_file: null,
      google_review_link: null,
      isModalOpen: false,
      toast: {
        open: false,
        message: "",
        severity: "success"
      },
      modifiedFields: new Set(),
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    })
  }


  fetchHotelProfile = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.hotelProfile(this.props.selectedHotelId.id))

    if (status == "success") {
      const {
        user_id,
        hotel_name,
        outlet_category,
        owner_name,
        email,
        website,
        adhar_number,
        fssai_number,
        shop_act_number,
        document_type,
        gst_number,
        bank_name,
        bank_branch_name,
        bank_account_number,
        bank_acc_holder_name,
        ifsc_code,
        currency,
        lat,
        lng,
        pan_file,
        adhar_file,
        fssai_file,
        shop_act_file,
        document_file,
        qr_image,
        logo,
        hotel_photo,
        qr_code,
        hotel_phone,
        address,
        apartment,
        city,
        state,
        country,
        pin_code,
        cancelled_cheque_file,
        gst_file,
        google_review_link,
      } = data

      console.log(data)
      this.setState(
        {
          google_review_link,
          user_id,
          hotel_name,
          outlet_category: outlet_category,
          owner_name,
          email,
          website,
          adhar_number,
          fssai_number,
          shop_act_number,
          document_type,
          gst_number,
          bank_account_number,
          bank_acc_holder_name,
          bank_name,
          bank_branch_name,
          cancelled_cheque_file,
          ifsc_code,
          currency,
          lat,
          lng,
          pan_file,
          adhar_file,
          fssai_file,
          shop_act_file,
          document_file,
          qr_image,
          logo,
          hotel_photo,
          qr_code,
          hotel_phone,
          address,
          apartment,
          city,
          state,
          country,
          pin_code,
          gst_file,
        },
        () => {
          this.setState({
            mounted: true,
          })
        },
      )
    }
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
      if (!hotel) {
          this.props.history.push(routes.admin.dashboard.root);
          return;
      }
    this.fetchHotelProfile()
    this.userLocation()
    this.getRestroOutletCategory()
  }

  getRestroOutletCategory = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.getRestroOutletCategory)

    if (status === "success") {
      console.log("outlet category", data)
      this.setState({
        outletCategories: data,
      })
    } else {
      this.showToast(message || "Failed to fetch outlet categories", "error")
    }
  }
  openModal = (type, title, message, buttonText = "Close", callback = null) => {
    this.setState({
      isModalOpen: true,
      modalType: type,
      modalTitle: title,
      modalMessage: message,
      modalButtonText: buttonText,
      modalCallback: callback,
    })
  }

  closeModal = () => {
    const { modalCallback } = this.state
    this.setState({
      isModalOpen: false,
    })

    if (modalCallback) {
      modalCallback()
    }
  }
  userLocation = () => {
    getUserLocation((response) => {
      const {
        lat,
        lng,
        formatted,
        obj: { postcode, state, state_district } = {},
      } = response;

      console.log("Final location data:", response);

      this.setState({
        lat,
        lng,
        postcode,
        state,
        state_district,
      });
    });
  };


  createHotel = async () => {
    const formdata = new FormData(document.getElementById("hotelForm"))
    console.log("URL_PATH.updateHotel", this.props.selectedHotelId.id, URL_PATH.updateHotel)
    const phone = document.getElementById("phone").value
    console.log(formdata)
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.updateHotel(this.props.selectedHotelId.id),
      formdata,
    )

    if (status === "success") {
      console.log("Data", data)
      this.openModal("success", "Success", message)
    } else {
      this.openModal("error", "Error", message)
    }
  }

  updateHotel = async () => {
    const form = document.getElementById("hotelForm");
    const formdata = new FormData(form);
    const updatedFormData = new FormData();

    // Only append modified fields to the new FormData
    this.state.modifiedFields.forEach(field => {
      // Special handling for file inputs
      if (field.endsWith('_file') || field === 'logo' || field === 'hotel_photo') {
        const fileInput = document.querySelector(`[name="${field}"]`);
        if (fileInput && fileInput.files[0]) {
          updatedFormData.append(field, fileInput.files[0]);
        } else if (this.state[field]) {
          // If it's a previously uploaded file (string path)
          updatedFormData.append(field, this.state[field]);
        }
      } else {
        updatedFormData.append(field, this.state[field]);
      }
    });

    // Debug: Log what's being sent
    console.log("Modified fields being sent:", Array.from(this.state.modifiedFields));
    for (const [key, value] of updatedFormData.entries()) {
      console.log(`${key}: ${value instanceof File ? `File: ${value.name}` : value}`);
    }

    try {
      const { status, message, data } = await API(
        this,
        "post",
        URL_PATH.updateHotel(this.props.selectedHotelId.id),
        updatedFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status === "success") {
        this.showToast("Hotel profile updated successfully");
        // Reset modified fields after successful update
        this.setState({ modifiedFields: new Set() });
        this.fetchHotelProfile();
      } else {
        this.openModal("error", "Error", message);
      }
    } catch (error) {
      console.error("Update failed:", error);
      this.showToast("Failed to update hotel profile", "error");
    }
  };

  printQRCodes = async () => {
    const params = {
      id: this.props.selectedHotelId.id,
      export: "pdf",
      exportFile: `qr_codes_${this.props.selectedHotelId.id}_${Date.now()}.pdf`,
    }
    const response = await API(this, "post", URL_PATH.printQrCode, params)
  }

  handleFileChange = (event, obj) => {
    const selectedFile = event.target.files[0];
    console.log("Selected File:", selectedFile);

    var reader = new FileReader();

    reader.onload = (e) => {
      this.setState({
        logo: e.target.result,
        modifiedFields: new Set(this.state.modifiedFields).add('logo')
      });
    };

    reader.readAsDataURL(selectedFile);
  };

  CircularSkeletonWithEdit = () => {
    const handleEditClick = () => {
      document.getElementById("hotel_logo").click()
    }

    return (
      <Box
        onClick={handleEditClick}
        sx={{
          cursor: "pointer",
          position: "relative",
          width: 100,
          height: 100,
        }}
      >
        {isValid(this.state.logo) ? (
          <Box
            sx={{
              width: 100,
              height: 100,
              backgroundColor: "#02111b",

              borderRadius: "50%",
            }}
          >
            <img
              src={this.state.logo || "/placeholder.svg"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
              alt="Hotel Logo"
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: 100,
              height: 100,
              backgroundColor: "#02111b",
              borderRadius: "50%",
            }}
          ></Box>
        )}

        <IconButton
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            backgroundColor: "#FFC857",
            color: "#02111B",
            "&:hover": {
              backgroundColor: "#E6B54E",
            },
          }}
        >
          <EditIcon />
        </IconButton>

        <Input
          id="hotel_logo"
          type="file"
          name="logo"
          sx={{
            display: "none",
          }}
          onChange={(e) => this.handleFileChange(e, this)}
        />
      </Box>
    )
  }

  handleFileChange2 = (event, obj) => {
    const selectedFile = event.target.files[0]
    console.log("Selected File:", selectedFile)

    var reader = new FileReader()

    reader.onload = (e) => {
      obj.setState({
        hotel_photo: [{ photo: e.target.result }],
        modifiedFields: new Set(this.state.modifiedFields).add('hotel_photo')
      })
    }

    reader.readAsDataURL(selectedFile)
  }

  SquareSkeletonWithEdit = () => {
    const handleEditClick = () => {
      document.getElementById("hotel_photo").click()
    }

    return (
      <Box
        onClick={handleEditClick}
        sx={{
          cursor: "pointer",
          position: "relative",
          width: "100%",
          maxWidth: 320,
          height: 180,
        }}
      >
        {this.state.hotel_photo?.[0]?.photo != null ? (
          <Box
            sx={{
              width: "100%",
              height: 180,
            }}
          >
            <img
              src={this.state.hotel_photo?.[0]?.photo || "/placeholder.svg"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              alt="Hotel Photo"
            />
          </Box>
        ) : (
          <Box
            sx={{
              height: 180,
              width: "100%",
              backgroundColor: "#02111b",
              borderRadius: "8px",
            }}
          ></Box>
        )}

        <IconButton
          sx={{
            position: "absolute",
            bottom: 8,
            right: 8,
            backgroundColor: "#FFC857",
            color: "#02111B",
            "&:hover": {
              backgroundColor: "#E6B54E",
            },
          }}
        >
          <EditIcon />
        </IconButton>

        <Input
          id="hotel_photo"
          type="file"
          name="hotel_photo"
          sx={{
            display: "none",
          }}
          onChange={(e) => this.handleFileChange2(e, this)}
        />
      </Box>
    )
  }

  render() {
    const outlet = Capitalize(trimUnderScore(this.state.outlet_category))
    const outlet_category = outlet
    const { isModalOpen, modalType, modalTitle, modalMessage, modalButtonText } = this.state

    const { mounted } = this.state

    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {mounted && (
          <form
            id="hotelForm"
            name="hotelForm"
            onSubmit={(e) => {
              e.preventDefault()
              return this.updateHotel()
            }}
          >
            <Card sx={{ mb: 4, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
              <CardHeader
                title={
                  <Typography variant="h5" sx={{ color: "white" }}>
                    Basic Information
                  </Typography>
                }
                sx={{ borderBottom: "1px solid rgba(255, 200, 87, 0.2)" }}
              />
              <CardContent>
                <Grid container spacing={3} alignItems="center" justifyContent="center">
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={1}
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                      mb: { xs: 2, md: 0 },
                    }}
                  >
                    {this.CircularSkeletonWithEdit()}
                  </Grid>

                  <Grid item xs={12} sm={12} md={9}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={2}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <InputLabel id="type-select-label" sx={{ color: "white" }}>
                            Type
                          </InputLabel>
                          <Select
                            id="category"
                            name="outlet_category"
                            value={this.state.outlet_category}
                            label="Type"
                            onChange={(e) => {
                              this.setState({
                                outlet_category: e.target.value,
                              })
                            }}
                            // sx={{
                            //   backgroundColor: "#02111B", // Dropdown background color
                            //   backgroundImage: "none",
                            //   color: "white", // Text color
                            //   "& .MuiOutlinedInput-notchedOutline": {
                            //     borderColor: "#FFC857", // Border color
                            //   },
                            //   "&:hover .MuiOutlinedInput-notchedOutline": {
                            //     borderColor: "#FFC857", // Hover border color
                            //   },
                            //   "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            //     borderColor: "#FFC857", // Focus border color
                            //   },
                            // }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  backgroundColor: "#02111B", // Dropdown menu background color
                                  backgroundImage: "none",
                                  color: "white", // Dropdown menu text color
                                  "& .MuiMenuItem-root": {
                                    "&:hover": {
                                      backgroundColor: "#041A29", // Hover background color for items
                                    },
                                  },
                                },
                              },
                            }}
                          >
                            {this.state.outletCategories.map((item, index) => (
                              <MenuItem key={index} value={item.value} sx={{ color: "white" }}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <TextField
                            variant="outlined"
                            value={this.state.hotel_name}
                            onChange={(e) => {
                              this.setState({
                                hotel_name: e.target.value,
                                modifiedFields: new Set(this.state.modifiedFields).add('hotel_name')

                              })
                            }}
                            required
                            type="text"
                            id="name"
                            name="hotel_name"
                            label={`Enter ${outlet_category} name`}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <TextField
                            variant="outlined"
                            required
                            type="text"
                            id="owner"
                            name="owner_name"
                            label="Enter owner name"
                            value={this.state.owner_name}
                            onChange={(e) => {
                              this.setState({
                                owner_name: e.target.value,
                                modifiedFields: new Set(this.state.modifiedFields).add('owner_name')

                              })
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={2}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <InputLabel id="country-code-label" sx={{ color: "white" }}>
                            Country
                          </InputLabel>
                          <Select
                            id="country_code"
                            name="country_code"
                            label="Country"
                            value={this.state.hotel_phone_country_code || "+91"}
                            onChange={(e) => {
                              this.setState({
                                hotel_phone_country_code: e.target.value,
                                modifiedFields: new Set(this.state.modifiedFields).add('hotel_phone_country_code')

                              })
                            }}
                            // sx={{
                            //   backgroundColor: "#02111B", // Dropdown background color
                            //   color: "white", // Text color
                            //   "& .MuiOutlinedInput-notchedOutline": {
                            //     borderColor: "#FFC857", // Border color
                            //   },
                            //   "&:hover .MuiOutlinedInput-notchedOutline": {
                            //     borderColor: "#FFC857", // Hover border color
                            //   },
                            //   "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            //     borderColor: "#FFC857", // Focus border color
                            //   },
                            // }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  backgroundColor: "#02111B", // Dropdown menu background color
                                  backgroundImage: "none",
                                  color: "white", // Dropdown menu text color
                                  "& .MuiMenuItem-root": {
                                    "&:hover": {
                                      backgroundColor: "#041A29", // Hover background color for items
                                    },
                                  },
                                },
                              },
                            }}
                          >
                            {[
                              {
                                country_code: "+91",
                                country_name: "India",
                                country_flag_unicode: "🇮🇳",
                              },
                              {
                                country_code: "+1",
                                country_name: "United States",
                                country_flag_unicode: "🇺🇸",
                              },
                              {
                                country_code: "+44",
                                country_name: "United Kingdom",
                                country_flag_unicode: "🇬🇧",
                              },
                            ].map((item, index) => (
                              <MenuItem key={index} value={item.country_code} sx={{ color: "white" }}>
                                {item.country_flag_unicode} {item.country_code} {item.country_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <TextField
                            variant="outlined"
                            required
                            type="text"
                            id="phone"
                            name="phone"
                            label={`${outlet_category} Phone`}
                            value={this.state.hotel_phone ? this.state.hotel_phone[0]?.phone : ""}
                            onChange={(e) => {
                              this.setState({
                                hotel_phone: [
                                  {
                                    phone: e.target.value,
                                  },
                                ],
                                modifiedFields: new Set(this.state.modifiedFields).add('hotel_phone')

                              })
                            }}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <TextField
                            variant="outlined"
                            required
                            type="text"
                            id="email"
                            name="email"
                            label={`${outlet_category} Email`}
                            value={this.state.email}
                            onChange={(e) => {
                              this.setState({
                                email: e.target.value,
                                modifiedFields: new Set(this.state.modifiedFields).add('email')

                              })
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} md={2}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <TextField
                            variant="outlined"
                            required
                            type="text"
                            id="gst_number"
                            name="gst_number"
                            label="GST Number"
                            value={this.state.gst_number}
                            onChange={(e) => {
                              this.setState({
                                gst_number: e.target.value,
                                modifiedFields: new Set(this.state.modifiedFields).add('gst_number')

                              });
                            }}
                            disabled={Boolean(this.state.gst_number && this.state.gst_number.trim() !== "")}
                          />
                        </FormControl>
                      </Grid>



                      {/* Website Field - Full width on mobile, half on sm+ */}
                      <Grid item xs={12} sm={6} md={4}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <TextField
                            variant="outlined"
                            type="text"
                            id="website"
                            name="website"
                            label={`${outlet_category} Website (Optional)`}
                            value={this.state.website}
                            onChange={(e) => {
                              this.setState({
                                website: e.target.value,
                                modifiedFields: new Set(this.state.modifiedFields).add('website')

                              })
                            }}
                          />
                        </FormControl>
                      </Grid>

                      {/* Google Review Link - Full width on mobile, half on sm+ */}
                      <Grid item xs={12} sm={6} md={6}>
                        <FormControl variant="outlined" sx={{ mb: 2 }} fullWidth>
                          <TextField
                            variant="outlined"
                            type="text"
                            id="google_review_link"
                            name="google_review_link"
                            label={`${outlet_category} Google Review Link (Optional)`}
                            value={this.state.google_review_link}
                            onChange={(e) => {
                              this.setState({
                                google_review_link: e.target.value,
                                modifiedFields: new Set(this.state.modifiedFields).add('google_review_link')

                              })
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-end" } }}
                  >
                    {this.SquareSkeletonWithEdit()}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Card sx={{ mb: 4, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
              <CardHeader
                title={
                  <Typography variant="h5" sx={{ color: "white" }}>
                    Address Information
                  </Typography>
                }
                sx={{ borderBottom: "1px solid rgba(255, 200, 87, 0.2)" }}
              />
              <CardContent>
                <Grid container spacing={3}>
                  {/* Address Line 1 */}
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                      <TextField
                        variant="outlined"
                        required
                        type="text"
                        id="address_line_1"
                        name="address"
                        label="Address Line 1"
                        value={this.state.address}
                        onChange={(e) => this.setState({ address: e.target.value })}
                        disabled={!!this.state.address}

                      // sx={{
                      //   '& .MuiOutlinedInput-root': {
                      //     '& fieldset': { borderColor: '#FFC857' },
                      //     '&:hover fieldset': { borderColor: '#FFC857' },
                      //     '&.Mui-focused fieldset': { borderColor: '#FFC857' },
                      //     color: 'white'
                      //   },
                      //   '& .MuiInputLabel-root': { color: 'white' },
                      //   '& .MuiInputLabel-root.Mui-focused': { color: '#FFC857' }
                      // }}
                      />
                    </FormControl>
                  </Grid>

                  {/* Address Line 2 */}
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                      <TextField
                        variant="outlined"
                        required
                        type="text"
                        id="address_line_2"
                        name="apartment"
                        label="Address Line 2"
                        value={this.state.apartment}
                        onChange={(e) => this.setState({ apartment: e.target.value })}
                        disabled={!!this.state.apartment}

                      // sx={{
                      //   '& .MuiOutlinedInput-root': {
                      //     '& fieldset': { borderColor: '#FFC857' },
                      //     '&:hover fieldset': { borderColor: '#FFC857' },
                      //     '&.Mui-focused fieldset': { borderColor: '#FFC857' },
                      //     color: 'white'
                      //   },
                      //   '& .MuiInputLabel-root': { color: 'white' },
                      //   '& .MuiInputLabel-root.Mui-focused': { color: '#FFC857' }
                      // }}
                      />
                    </FormControl>
                  </Grid>

                  {/* City */}
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                      <TextField
                        variant="outlined"
                        required
                        type="text"
                        id="city"
                        name="city"
                        label="City"
                        value={this.state.city}
                        onChange={(e) => this.setState({ city: e.target.value })}
                        disabled={!!this.state.city}

                      // sx={{
                      //   '& .MuiOutlinedInput-root': {
                      //     '& fieldset': { borderColor: '#FFC857' },
                      //     '&:hover fieldset': { borderColor: '#FFC857' },
                      //     '&.Mui-focused fieldset': { borderColor: '#FFC857' },
                      //     color: 'white'
                      //   },
                      //   '& .MuiInputLabel-root': { color: 'white' },
                      //   '& .MuiInputLabel-root.Mui-focused': { color: '#FFC857' }
                      // }}
                      />
                    </FormControl>
                  </Grid>

                  {/* State */}
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                      <TextField
                        variant="outlined"
                        required
                        type="text"
                        id="state"
                        name="state"
                        label="State"
                        value={this.state.state}
                        onChange={(e) => this.setState({ state: e.target.value })}
                        disabled={!!this.state.state}

                      // sx={{
                      //   '& .MuiOutlinedInput-root': {
                      //     '& fieldset': { borderColor: '#FFC857' },
                      //     '&:hover fieldset': { borderColor: '#FFC857' },
                      //     '&.Mui-focused fieldset': { borderColor: '#FFC857' },
                      //     color: 'white'
                      //   },
                      //   '& .MuiInputLabel-root': { color: 'white' },
                      //   '& .MuiInputLabel-root.Mui-focused': { color: '#FFC857' }
                      // }}
                      />
                    </FormControl>
                  </Grid>

                  {/* Country */}
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControl fullWidth sx={{ mb: { xs: 2, md: 0 } }}>
                      <TextField
                        variant="outlined"
                        required
                        type="text"
                        id="country"
                        name="country"
                        label="Country"
                        value={this.state.country}
                        onChange={(e) => this.setState({ country: e.target.value })}
                        disabled={!!this.state.country}

                      // sx={{
                      //   '& .MuiOutlinedInput-root': {
                      //     '& fieldset': { borderColor: '#FFC857' },
                      //     '&:hover fieldset': { borderColor: '#FFC857' },
                      //     '&.Mui-focused fieldset': { borderColor: '#FFC857' },
                      //     color: 'white'
                      //   },
                      //   '& .MuiInputLabel-root': { color: 'white' },
                      //   '& .MuiInputLabel-root.Mui-focused': { color: '#FFC857' }
                      // }}
                      />
                    </FormControl>
                  </Grid>

                  {/* Pincode */}
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        required
                        type="text"
                        id="pincode"
                        name="pin_code"
                        label="Pincode"
                        value={this.state.pin_code}
                        onChange={(e) => this.setState({ pin_code: e.target.value })}
                        disabled={!!this.state.pin_code}

                      // sx={{
                      //   '& .MuiOutlinedInput-root': {
                      //     '& fieldset': { borderColor: '#FFC857' },
                      //     '&:hover fieldset': { borderColor: '#FFC857' },
                      //     '&.Mui-focused fieldset': { borderColor: '#FFC857' },
                      //     color: 'white'
                      //   },
                      //   '& .MuiInputLabel-root': { color: 'white' },
                      //   '& .MuiInputLabel-root.Mui-focused': { color: '#FFC857' }
                      // }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Coordinates Row */}
                <Grid container spacing={3} sx={{ mt: 1 }} alignItems="center">
                  {/* Combined Latitude/Longitude Container - 70% width */}
                  <Grid item xs={12} sm={8} md={7} lg={7}>
                    <Grid container spacing={2}>
                      {/* Latitude - Half of 70% (35%) */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          variant="outlined"
                          required
                          fullWidth
                          type="text"
                          id="lat"
                          name="lat"
                          label="Latitude"
                          value={this.state.lat}
                          onChange={(e) => this.setState({ lat: e.target.value })}
                          InputProps={{
                            style: {
                              fontSize: '1.1rem'  // Ensure input text size
                            }
                          }}
                          InputLabelProps={{
                            shrink: true,  // This forces the label to always be shrunk at the top
                            style: {
                              fontSize: '1.1rem',
                              backgroundColor: 'background.paper', // Prevents transparent background issues
                              padding: '0 4px', // Adds some padding for better appearance
                              transform: 'translate(14px, -6px) scale(0.75)' // Fine-tune position if needed
                            }
                          }}
                          disabled={!!this.state.lat}

                        />
                      </Grid>

                      {/* Longitude - Half of 70% (35%) */}
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <TextField
                            variant="outlined"
                            required
                            type="text"
                            id="lng"
                            name="lng"
                            label="Longitude"
                            value={this.state.lng}
                            onChange={(e) => this.setState({ lng: e.target.value })}
                            disabled={!!this.state.lng}

                            InputLabelProps={{
                              shrink: true,  // This forces the label to always be shrunk at the top
                              style: {
                                fontSize: '1.1rem',
                                backgroundColor: 'background.paper', // Prevents transparent background issues
                                padding: '0 4px', // Adds some padding for better appearance
                                transform: 'translate(14px, -6px) scale(0.75)' // Fine-tune position if needed

                              }

                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Detect Current Location Button - 30% width */}
                  <Grid item xs={12} sm={4} md={5} lg={3}>
                    <Button
                      variant="contained"
                      onClick={this.userLocation}
                      sx={{
                        backgroundColor: '#FFC857',
                        color: '#02111B',
                        fontWeight: 'bold',
                        py: 2,  // Increased padding
                        px: 4,  // Increased padding
                        // fontSize: '1.1rem',  // Larger text
                        '&:hover': {
                          backgroundColor: '#E6B54E',
                          transform: 'scale(1.02)'  // Slight grow effect
                        },
                        whiteSpace: 'nowrap',
                        width: '100%',
                        height: '60px',  // Match increased field height
                        transition: 'all 0.2s ease',  // Smooth hover effect
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'  // Subtle shadow
                      }}
                    >
                      Detect Live Location
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>


            </Card>




            <Card sx={{ mb: 4, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
              <CardHeader
                title={
                  <Typography variant="h5" sx={{ color: "white" }}>
                    Documents
                  </Typography>
                }
                sx={{ borderBottom: "1px solid rgba(255, 200, 87, 0.2)" }}
              />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FileUploadWithPreview
                      label="Upload Shop Act license"
                      id="shopAct"
                      name="shop_act_file"
                      accept="image/*"
                      value={this.state.shop_act_file}
                      onChange={(file) => {
                        this.setState(prevState => ({
                          shop_act_file: file,
                          modifiedFields: new Set(prevState.modifiedFields).add('shop_act_file')
                        }))
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FileUploadWithPreview
                      label="Upload FSSAI license"
                      id="fssai"
                      name="fssai_file"
                      accept="image/*"
                      value={this.state.fssai_file}
                      onChange={(file) => {
                        this.setState(prevState => ({
                          fssai_file: file,
                          modifiedFields: new Set(prevState.modifiedFields).add('fssai_file')
                        }))
                      }}
                    />

                  </Grid>

                  {/* <Grid item xs={12} sm={6} md={4}>
                    <FileUploadWithPreview
                      label="Upload Adhar Card"
                      id="adhar"
                      name="adhar_file"
                      accept="image/*"
                      value={this.state.adhar_file}
                      onChange={(file) => {
                        this.setState({ adhar_file: file })
                      }}
                    />
                  </Grid> */}

                  <Grid item xs={12} sm={6} md={4}>
                    <FileUploadWithPreview
                      label="Upload GST Certificate"
                      id="gst"
                      name="gst_file"
                      accept="image/*"
                      value={this.state.gst_file}
                      onChange={(file) => {
                        this.setState(prevState => ({
                          gst_file: file,
                          modifiedFields: new Set(prevState.modifiedFields).add('gst_file')
                        }))
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={12} sm={6} md={4}>
                    <FileUploadWithPreview
                      label="Upload Pan Card"
                      id="pan"
                      name="pan_file"
                      accept="image/*"
                      value={this.state.pan_file}
                      onChange={(file) => {
                        this.setState({ pan_file: file })
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FileUploadWithPreview
                      label="Upload Cancelled Cheque"
                      id="cancelled_cheque"
                      name="cancelled_cheque_file"
                      accept="image/*"
                      value={this.state.cancelled_cheque_file}
                      onChange={(file) => {
                        this.setState({ cancelled_cheque_file: file })
                      }}
                    />
                  </Grid> */}
                </Grid>
              </CardContent>
            </Card>



            <Box mt={4} textAlign="">
              <Button
                variant="contained"
                size="large"
                type="submit"
                sx={{
                  backgroundColor: "#FFC857",
                  color: "#02111B",
                  fontWeight: "bold",
                  px: 4,
                  py: 1.5,
                  "&:hover": {
                    backgroundColor: "#E6B54E",
                  },
                }}
              >
                Update {Capitalize(trimUnderScore(this.state.outlet_category))} Profile
              </Button>
            </Box>
          </form>
        )}

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Container>


    )
  }
}

export default redux(ListHotelScreen)

